<div
  class="tag-input-field input-field-wrap"
  [class.compact]="compact"
  [style.min-height.px]="height ?? undefined"
  cdkOverlayOrigin
  #fieldOrigin="cdkOverlayOrigin"
  (click)="openMenu()"
>
  <div class="tag-input-content">
    @for (item of applied; track item.ID; let i = $index) {
      <motn-pill [removable]="true" (remove)="removeTag(i)">{{ item.Label }}</motn-pill>
    }

    <input
      class="tag-search"
      [class.compact-search]="applied.length > 0"
      [placeholder]="applied.length === 0 ? 'Add tags…' : ''"
      readonly
      (click)="$event.stopPropagation(); openMenu()"
    >
  </div>

  @if (showChevron) {
    <i class="fa-regular fa-chevron-down"></i>
  }
</div>

@if (menuOpen) {
  <motn-popover-multi-select
    [externalOrigin]="fieldOrigin"
    [triggerEl]="fieldOrigin.elementRef.nativeElement"
    [optionGroup]="dropdownOptions"
    [inputPlaceholder]="'Search or create a tag…'"
    [loading]="loading"
    [createLabel]="createLabel"
    [createDisabled]="!canCreate"
    [capitalizeInput]="true"
    [autoFocusSearch]="true"
    [overlayPositions]="overlayPositions"
    (clickedOption$)="onOptionClicked($event)"
    (createClicked$)="createTag($event)"
    (clickedOutsideMenu$)="closeMenu()"
    (searchTermChange)="onSearchTermChange($event)"
  ></motn-popover-multi-select>
}
